"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/admin-portal.svg.js",
    _path,
    _path2,
    _path3,
    _path4,
    _path5,
    _path6;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    width: 306,
    height: 37,
    viewBox: "0 0 306 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M83.42 17.398h3.948l7.394 18.523h-4.108l-1.59-4.028h-7.34l-1.59 4.028H76l7.42-18.523zm4.584 11.288l-2.623-7.049-2.624 7.05h5.247zM100.1 17.398h6.44c2.014 0 3.772.37 5.273 1.113 1.502.742 2.659 1.802 3.472 3.18.812 1.378 1.219 3.003 1.219 4.876 0 3.073-.901 5.405-2.703 6.995-1.785 1.573-4.276 2.359-7.473 2.359H100.1V17.398zm6.44 15.158c1.89 0 3.339-.53 4.346-1.59 1.007-1.06 1.51-2.527 1.51-4.4 0-1.113-.221-2.11-.662-2.994a4.86 4.86 0 00-1.935-2.067c-.848-.495-1.846-.742-2.994-.742h-2.677v11.793h2.412zM121.833 17.398h3.975l5.698 12.401 5.724-12.401h3.948V35.92h-3.842v-10.52l-4.903 10.52h-1.855l-4.876-10.52v10.52h-3.869V17.398zM147.059 17.398h4.028V35.92h-4.028V17.398zM156.966 17.398h3.922l7.738 11.977V17.398h4.028V35.92h-3.896l-7.764-11.978v11.978h-4.028V17.398zM190.882 17.398h7.791c2.102 0 3.781.556 5.035 1.669 1.254 1.095 1.881 2.623 1.881 4.584 0 2.015-.627 3.56-1.881 4.638-1.237 1.078-2.915 1.616-5.035 1.616h-3.763v6.016h-4.028V17.398zm7.208 9.142c2.279 0 3.418-.963 3.418-2.889 0-1.077-.309-1.828-.927-2.252-.601-.424-1.431-.636-2.491-.636h-3.18v5.777h3.18zM219.537 36.319c-1.855 0-3.542-.407-5.061-1.22a9.101 9.101 0 01-3.551-3.391c-.866-1.467-1.299-3.145-1.299-5.035 0-1.89.433-3.57 1.299-5.035a9.045 9.045 0 013.551-3.419c1.519-.813 3.206-1.219 5.061-1.219s3.525.406 5.009 1.219a9.058 9.058 0 013.551 3.418c.865 1.467 1.298 3.145 1.298 5.035 0 1.89-.433 3.57-1.298 5.035a9.115 9.115 0 01-3.551 3.392c-1.484.813-3.154 1.22-5.009 1.22zm0-3.71c1.06 0 2.023-.239 2.889-.716a5.47 5.47 0 002.093-2.067c.513-.901.769-1.952.769-3.154 0-1.183-.256-2.217-.769-3.1a5.056 5.056 0 00-2.067-2.067c-.865-.495-1.837-.742-2.915-.742-1.095 0-2.084.247-2.968.742-.865.477-1.554 1.166-2.067 2.067-.512.883-.768 1.917-.768 3.1 0 1.202.256 2.253.768 3.154a5.473 5.473 0 002.094 2.067c.883.477 1.864.715 2.941.715zM234.71 17.398h8.029c2.103 0 3.737.53 4.903 1.59 1.184 1.042 1.775 2.552 1.775 4.531 0 1.378-.318 2.553-.954 3.525-.636.953-1.537 1.651-2.703 2.093l3.525 6.784h-4.134l-3.26-6.28h-3.153v6.28h-4.028V17.398zm7.314 8.877c1.025 0 1.828-.22 2.411-.662.601-.442.901-1.14.901-2.094 0-1.007-.291-1.714-.874-2.12-.583-.424-1.396-.636-2.438-.636h-3.286v5.512h3.286zM258.254 20.763h-5.406v-3.366h14.84v3.366h-5.406v15.158h-4.028V20.763zM276.137 17.398h3.949l7.393 18.523h-4.107l-1.59-4.028h-7.341l-1.59 4.028h-4.134l7.42-18.523zm4.585 11.288l-2.624-7.049-2.623 7.05h5.247zM292.818 17.398h4.028v15.158h8.48v3.365h-12.508V17.398z",
    fill: "#2A2A2A",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13
    },
    __self: this
  })), _path2 || (_path2 = React.createElement("path", {
    d: "M77.67 12.049V6.514c.676-.968 1.44-1.452 2.296-1.452.585 0 .99.138 1.215.414.225.276.337.745.337 1.409v5.164h1.654l-.001-5.263a5.598 5.598 0 00-.033-.61c.54-.742 1.238-1.114 2.093-1.114.596 0 1.018.138 1.265.414.248.276.372.745.372 1.409v5.164h1.653V6.666c0-.98-.22-1.719-.658-2.22-.439-.5-1.153-.75-2.143-.75-.529 0-1.055.112-1.578.337a3.455 3.455 0 00-1.325.996c-.18-.45-.46-.785-.843-1.004-.383-.22-.9-.33-1.553-.33-.517 0-1.018.119-1.502.355-.483.236-.916.59-1.299 1.063V3.95H76v8.1h1.67zm14.86 3.341c.742 0 1.347-.194 1.814-.582.467-.388.87-1.004 1.207-1.848l3.645-9.011H97.44l-2.515 6.227-2.7-6.227h-1.755l3.544 7.897-.388.945c-.18.439-.383.757-.608.954-.225.197-.534.295-.928.295-.427 0-.787-.056-1.08-.169v1.333c.405.124.912.186 1.519.186zm11.636-3.088c1.429 0 2.509-.281 3.24-.844.732-.562 1.097-1.356 1.097-2.38 0-.63-.121-1.155-.363-1.577a3.094 3.094 0 00-1.054-1.072c-.462-.292-1.092-.602-1.89-.928-.72-.292-1.263-.537-1.629-.734-.365-.197-.641-.422-.827-.675-.185-.253-.278-.565-.278-.936 0-.54.214-.957.641-1.25.428-.292 1.046-.438 1.856-.438 1.002 0 1.992.22 2.97.658V.641a6.832 6.832 0 00-1.518-.49A9.093 9.093 0 00104.673 0c-.788 0-1.485.132-2.093.397-.608.264-1.08.635-1.417 1.113a2.779 2.779 0 00-.507 1.646c0 .82.248 1.501.743 2.041s1.299 1.035 2.413 1.486c.81.326 1.395.582 1.755.767.36.186.636.402.827.65.191.248.287.574.287.979 0 1.181-.878 1.772-2.633 1.772a8.125 8.125 0 01-3.493-.76v1.553c.416.202.953.363 1.612.48a11.29 11.29 0 001.999.178zm12.615 0c1.8 0 3.206-.422 4.219-1.266v-1.67a5.424 5.424 0 01-1.831 1.054c-.658.22-1.403.33-2.236.33-.9 0-1.701-.186-2.405-.557a4.048 4.048 0 01-1.653-1.604c-.4-.697-.599-1.507-.599-2.43 0-.922.196-1.73.59-2.421a4.01 4.01 0 011.646-1.595c.703-.371 1.51-.557 2.421-.557 1.631 0 2.936.433 3.915 1.3V1.232C119.757.41 118.401 0 116.781 0c-1.215 0-2.295.253-3.24.76a5.442 5.442 0 00-2.21 2.16c-.529.933-.793 2.013-.793 3.24 0 1.226.264 2.303.793 3.23a5.457 5.457 0 002.21 2.152c.945.507 2.025.76 3.24.76zm8.734-.253V7.543h2.818c1.283 0 2.29-.306 3.021-.92.731-.613 1.097-1.516 1.097-2.708 0-1.17-.369-2.073-1.106-2.708-.737-.636-1.741-.954-3.012-.954h-4.539V12.05h1.721zm2.632-5.94h-2.632V1.704h2.632c.788 0 1.412.166 1.874.498.461.332.692.903.692 1.713s-.231 1.378-.692 1.704c-.462.327-1.086.49-1.874.49z",
    fill: "#7B7B7D",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17
    },
    __self: this
  })), _path3 || (_path3 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.405 4H7.08L0 15.256l19.32-.172L26.405 4z",
    fill: "#63676B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 21
    },
    __self: this
  })), _path4 || (_path4 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.32 15.084l7.828 17.859 7.333-13.308L26.413 4 19.32 15.084z",
    fill: "#BCCB32",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27
    },
    __self: this
  })), _path5 || (_path5 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 19.635L48.533 35.166h-15.74l7.88-15.533L59 19.635z",
    fill: "#63676B",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33
    },
    __self: this
  })), _path6 || (_path6 = React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.998 19.635L48.381 4h-15.48l7.75 15.592 18.347.043z",
    fill: "#BCCB32",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 39
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;